import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3 2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1h9a3 3 0 0 1 3 3v12a3 3 0 0 1-2 2.83V22a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1.17A3 3 0 0 1 1 18V6c0-1.306.835-2.417 2-2.83zm1 3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm13.6 2.2a1 1 0 0 1 .2 1.4L16 11h2a1 1 0 0 1 .8 1.6l-3 4a1 1 0 0 1-1.6-1.2L16 13h-2a1 1 0 0 1-.8-1.6l3-4a1 1 0 0 1 1.4-.2M5 10a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1"
    }, null, -1)
  ]))]))
}
export default { render: render }